import dataType from '../dataType';

const symbol = {
    name: 'SYMBOL',
    type: dataType.string
};

export default symbol;
